// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3zXm3","insightsList":"newBusinessInsightsMenu_insightsList__3gVrD","active":"newBusinessInsightsMenu_active__1bL-J"};